import React from "react";

const Footer = () => {
  return (
    <footer>
      <div className="container">
        &copy; {new Date().getFullYear()} Leclerc Psychological Services. All
        rights reserved.
      </div>
    </footer>
  );
};

export default Footer;
